import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=3b4ce8d6"
import script from "./HistoryDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports